var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.319 14.433a8 8 0 10-1.412 1.411l.043.045 4.242 4.243a1 1 0 001.415-1.415l-4.243-4.242a1.117 1.117 0 00-.045-.042zm-2.076-9.15a6 6 0 11-8.417 8.555 6 6 0 018.417-8.555z"
  })));
}

export default "/images/search.svg?bf008c933c9024e8c8c914de691a781a";
export { SvgSearch as ReactComponent };